import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createParagraphNode, $createTextNode, $getRoot } from 'lexical';
import { useEffect, useRef } from 'react';

type PlainInitialValuePluginProps = {
  value: string;
};

export const PlainInitialValuePlugin = ({
  value,
}: PlainInitialValuePluginProps): null => {
  const [editor] = useLexicalComposerContext();
  const initializedValueRef = useRef<string | null>(null);

  useEffect(() => {
    const currentText = editor
      .getEditorState()
      .read(() => $getRoot().getTextContent());

    if (
      initializedValueRef.current === null ||
      (value === '' && currentText !== '')
    ) {
      editor.update(() => {
        const root = $getRoot();
        root.clear();
        if (value) {
          const paragraph = $createParagraphNode();
          paragraph.append($createTextNode(value));
          root.append(paragraph);
        }
      });
      initializedValueRef.current = value;
    }
  }, [editor, value]);

  return null;
};
